import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { Modal } from 'foundations-components/transitional/components/Modal';
import HubSpotLogo from '../HubSpotLogo';
import { HR } from 'foundations-components/transitional/components/HR';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { getFullUrl } from 'hubspot-url-utils';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EnrollmentFlowType } from '../../types';
// @ts-expect-error Image import
import StripeLogo from 'bender-url!../../../images/StripeLogo.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  CELEBRATION_MODAL: 'celebration-modal',
  CELEBRATION_MODAL_CLOSE_BUTTON: 'celebration-modal-close-button'
};
const academyEmbedVideoUrl = `${getFullUrl('app', {
  envOverride: 'prod'
})}/embedded-academy-ui/static?shortId=6673278`;
const CelebrationModalV2 = ({
  currentEnrollmentFlow,
  title,
  subTitle,
  bodyContent,
  primaryCTA,
  secondaryCTA,
  onClose,
  testID,
  width
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    centered: true,
    width: width || 1200,
    "data-test-id": testID || TEST_IDS.CELEBRATION_MODAL,
    use: "fullscreen",
    children: [/*#__PURE__*/_jsxs(DialogBody, {
      paddingInline: "0",
      children: [/*#__PURE__*/_jsx(Confetti, {}), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        blockSize: "100%",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          marginInline: "1600",
          children: [/*#__PURE__*/_jsxs(View, {
            inlineSize: "45%",
            children: [/*#__PURE__*/_jsx(View, {
              marginBlockStart: "400",
              marginBlockEnd: "600",
              children: /*#__PURE__*/_jsx(Flex, {
                justifyContent: "start",
                children: currentEnrollmentFlow === EnrollmentFlowType.native ? /*#__PURE__*/_jsx(HubSpotLogo, {
                  title: unescapedText('altText.hubspotLogo'),
                  width: "60px",
                  height: "60px"
                }) : /*#__PURE__*/_jsx(Image, {
                  src: StripeLogo,
                  title: unescapedText('altText.stripeLogo'),
                  width: "60px",
                  height: "60px"
                })
              })
            }), /*#__PURE__*/_jsxs(View, {
              marginBlockEnd: "300",
              textAlign: "left",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h1",
                marginBlockEnd: "800",
                children: title
              }), /*#__PURE__*/_jsx(Text, {
                as: "h3",
                marginBlockEnd: "800",
                children: subTitle
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                marginBlockEnd: "600",
                children: bodyContent
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              gap: "300",
              marginBlockEnd: "700",
              children: [primaryCTA, secondaryCTA]
            })]
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "10%",
            blockSize: "100%"
          }), /*#__PURE__*/_jsx(Flex, {
            inlineSize: "45%",
            alignItems: "center",
            children: /*#__PURE__*/_jsx(View, {
              borderWidth: "300",
              borderStyle: "solid",
              borderColor: "text-primary-disabled",
              inlineSize: "100%",
              children: /*#__PURE__*/_jsx("iframe", {
                width: "100%",
                style: {
                  aspectRatio: '16/9',
                  height: 'fit-content'
                },
                title: unescapedText('invoices.components.modals.videoModal.title'),
                referrerPolicy: "strict-origin-when-cross-origin",
                allowFullScreen: true,
                allow: "autoplay; fullscreen",
                src: academyEmbedVideoUrl
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      paddingInline: "0",
      children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Button, {
        use: "link-on-bright",
        marginInlineStart: "1200",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "celebrationModal.cancelButton"
        })
      })]
    })]
  });
};
export default CelebrationModalV2;